/**
 * file_submit_controller.js — one-button file upload (Stimulus).
 *
 * Lets a single visible button stand in for a file <input> + submit: the button
 * opens the OS file dialog, and choosing a file submits the surrounding form.
 * Mount on the <form> (data-controller="file-submit"); a hidden file input
 * carries data-file-submit-target="input" and data-action="change->file-submit#submit",
 * and the trigger button fires data-action="file-submit#browse".
 *
 * Used by the SWMS seed-hazard admin library import button.
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["input"];

    browse() {
        this.inputTarget.click();
    }

    submit() {
        if (this.inputTarget.files.length) this.element.requestSubmit();
    }
}
